import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-customer-company-setting-activation-modal',
  templateUrl: './company-setting-activation-modal.component.html',
})
export class BaseCustomerCompanySettingActivationModalComponent {
  @Input({ required: true }) confirmationText: string;
  @Input({ required: true }) settingDescription: string;
}
